<template>
  <v-container>
    <v-card>
      <v-row clas="bm-0 mb-0 pb-0">
       <v-col cols="12">
          <v-card-subtitle class="ml-2">
            <h2 class="text-uppercase indigo--text">
              {{ currentUser.nombre }} {{ currentUser.primer_apellido }} {{ currentUser.segundo_apellido }}
            </h2>
            <h4 class="text-uppercase" style="color: #616161">
              {{ currentUser.roles[0].descripcion }}
            </h4>
            <v-divider class="mt-1"/>
            <v-btn
            small
            class="white--text mt-1"
            style="float: right;"
            color="#276090"
            @click="$router.push({ name:'Comunicados' })"
          ><v-icon class="mr-2">mdi-arrow-left</v-icon>REGRESAR
          </v-btn>
          </v-card-subtitle>
        </v-col>
      </v-row>
      
      <v-card-text>
        <v-form @submit.prevent="save" ref="form" v-model="valid" lazy-validation>

          <!-- Multifirma -->
          <!-- <v-card class="mx-4" color="#CED7DB"> -->
          <v-toolbar color="#c89e40" dark dense>
            <v-toolbar-title class="text-uppercase font-weight-bold">
              Agregar Comunicado a la apelacion electrónica
            </v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
        <!-- </v-card> -->
      <div v-if="currentApelacion.juzgado">
        <TableDetallesApelacion :apelacion="currentApelacion" />   
      </div>

          <!-- <v-card> -->

            <v-row class="mt-2">
              <v-col cols="12" md="6" align="center" v-if="!currentEnvio">
                <v-select
                  :items="listTipoEnvios"
                  v-model="tipo_envio_id"
                  :loading="listTipoEnvios.length==0"
                  label="Seleccione el tipo de envio"
                  prepend-icon="mdi-message-arrow-right-outline"
                  item-value="id"
                  item-text="nombre"
                  outlined
                  :rules="[v => !!v|| 'Campo requerido']"
                  :readonly="currentEnvio ? true : false"
                >
                </v-select>
              </v-col>
              <v-col cols="12" md="6" v-show="!currentEnvio">
                <v-text-field
                  outlined
                  v-model="num_oficio"
                  label="Núm. Oficio"
                  prepend-icon="mdi-pound"
                  :rules="[v => !!v.trim()|| 'Campo requerido']"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="">
              <v-col cols="12" md="6" align="center">
                <v-select
                  :items="listCategorias"
                  v-model="categoria"
                  return-object
                  @change="getTipoDocumento()"
                  label="Seleccione categoría de documento"
                  prepend-icon="mdi-menu"
                  item-value="id"
                  item-text="nombre"
                  outlined
                  :rules="[v => !!v|| 'Campo requerido']"
                  >
                </v-select>
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  :disabled="!categoria"
                  :loading="listTipo.length==0 && categoria!=''"
                  :items="listTipo"
                  return-object
                  v-model="tipo_documento"
                  label="Seleccione tipo de documento"
                  prepend-icon="mdi-menu-down"
                  item-value="id"
                  item-text="nombre"
                  clearable
                  outlined
                  :rules="[v => !!v|| 'Campo requerido']"
                  >
                </v-select>
              </v-col>
            </v-row>

            <v-row v-if="categoria && tipo_documento.nombre == 'Otro'" class="mt-n7">
              <v-col cols="12">
                <v-textarea
                  v-model="leyenda"
                  outlined
                  label="Especifique (leyenda)"
                  prepend-inner-icon="mdi-file-document-outline"
                  rows="1"
                  row-height="10"
                  counter="100"
                  maxlength="100"
                  hint="Máximo 100 caracteres"
                  :rules=" [v => !!v || 'Campo requerido',
                            v => v.length <= 100 || 'Requiere 100 caracteres']"
                ></v-textarea>
              </v-col>
            </v-row>

            <v-row class="mt-n7">
                <v-col cols="12">
                  <v-textarea
                    v-model="extracto"
                    outlined
                    label="Extracto"
                    prepend-inner-icon="mdi-file-document-outline"
                    rows="3"
                    row-height="20"
                    counter="200"
                    maxlength="200"
                    hint="Máximo 200 caracteres"
                    :rules=" [v => v.length <= 200 || 'Requiere 200 caracteres']"
                  ></v-textarea>
                </v-col>
              </v-row>

            <v-row class="mt-n7">
              <v-col cols="12" v-show="!currentEnvio">
                <v-textarea
                  v-model="asunto"
                  outlined
                  label="Asunto"
                  rows="2"
                  row-height="20"
                  counter="100"
                  maxlength="100"
                  hint="Máximo 100 caracteres"
                  :rules=" [v => !!v || 'Campo requerido',
                            v => v.length <= 100 || 'Requiere 100 caracteres']"
                ></v-textarea>
              </v-col>
            </v-row>

            <v-row v-if="roleUser != 'relator'" class="mt-n3">
              <v-col cols="12" md="9" align="center">
                <v-file-input
                  v-model="file"
                  label="Seleccione archivo"
                  show-size
                  accept="application/pdf"
                  truncate-length="50"
                  :rules="fileRules"
                  @change="SelccionarArchivo($event)"
                  :disabled="archivo.encode != ''"
                ></v-file-input>
              </v-col>
            </v-row>

            <v-row class="mt-n3" v-if="roleUser == 'relator'">
              <v-col cols="12" md="12" align="center">
                <v-btn
                dark
                color="pink"
                :loading="loadingResolucion"
                @click="getFile()"
              >
                <v-icon left>
                  mdi-file-document
                </v-icon>
                Ver Proyecto de Resolución
              </v-btn>
              </v-col>
            </v-row>

            <v-container fluid v-if="roleUser == 'secacu'">
              <h2 style="color: #B08836" class="font-weight-bold"> Seleccione una opción</h2><br>
              <hr>
              <v-radio-group
                v-model="sign"
                column
                :rules="[v => !!v|| 'Seleccione una opción']"
              >
                <v-radio
                  label="El documento requiere únicamente de mi firma electrónica"
                  value="1"
                ></v-radio>
                <v-radio
                  label="El documento requiere de dos o más firmas"
                  value="2"
                ></v-radio>
                <v-radio
                  label="El documento NO requiere firmas"
                  value="3"
                ></v-radio>
              </v-radio-group>
            </v-container>

            <v-container v-if="sign == '1'" fluid class="mt-n5">
              <!-- FIRMAR DOCUMENTO  -->
                <h2 style="color: #B08836" class="font-weight-bold"> Firmar documento</h2><br>
                <v-row class="">
                  <v-col md="8" align="">
                    <v-file-input
                      v-model="file_firel"
                      color="blue darken-2"
                      label="Seleccionar la firel"
                      prepend-icon="mdi-certificate"
                      outlined
                      dense
                      show-size
                      accept=".pfx"
                      @change="SeleccionarPfx($event)"
                      truncate-length="50"
                      :disabled="archivo.encode != ''"
                    ></v-file-input>
                  </v-col>
                </v-row>

                <v-row class="mt-n6">
                  <v-col cols="8">
                    <v-text-field outlined dense
                      v-model="password"
                      label="Contraseña"
                      type="text"
                      prepend-icon="mdi-lock-outline"
                      :type="showpass ? 'text' : 'password'"
                      :append-icon="showpass ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="showpass = !showpass"
                      truncate-length="50"
                      :disabled="archivo.encode != ''"
                    >
                    </v-text-field>
                  </v-col>
                </v-row>
                <v-row class="mt-n6 ml-5">
                  <v-col cols="2">
                    <v-btn
                      :loading="loadingFirma"
                      v-model="activarBoton"
                      @click="firmar()"
                      :disabled="!activarBoton || (file && file.size > 20971520)"
                      color="primary">FIRMAR FIREL
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row>
                <v-col v-if="archivo.file_name" class="ml-6">
                  <ul>
                    <li>
                      <h3><b>Documento Firmado:</b>
                        {{ archivo.file_name }}
                        <v-icon
                          color="green"
                      >mdi-check</v-icon>&nbsp;
                        <v-btn
                        x-small
                        @click="saveTextAsFile()"
                        color="primary">Ver Evidencia
                        </v-btn>&nbsp;
                      </h3>
                    </li>
                  </ul>
                </v-col>
              </v-row>
            </v-container>

            <!--CREAR MULTIFIRMA -->
            <v-container v-if="sign == '2'" fluid class="mt-n5">
              <h2 style="color: #B08836" class="font-weight-bold"> Seleccione firmantes del documento</h2><br>
              <v-row>
              <v-col cols="12" md="12">
                <v-autocomplete
                  v-model="magistrado"
                  :items="listMagistrados"
                  outlined
                  @change="addMagistrado()"
                  item-text="nombre"
                  item-value="id"
                  return-object
                  label="Seleccione Firmante"
                  prepend-icon="mdi-account"
                  persistent-hint
                  no-data-text="No se encontraron usuarios"
                  required
                >
                <template slot="selection" slot-scope="data">
                  <div v-if="data.item.segundo_apellido"class="select-text">
                    {{ data.item.nombre +' '+data.item.primer_apellido +' '+data.item.segundo_apellido}}
                  </div>
                  <div v-else class="select-text">
                    {{ data.item.nombre +' '+data.item.primer_apellido}}
                  </div>
                </template>
                <template slot="item" slot-scope="data">
                  <div v-if="data.item.segundo_apellido"class="select-text">
                    {{ data.item.nombre +' '+data.item.primer_apellido +' '+data.item.segundo_apellido}}
                  </div>
                  <div v-else class="select-text">
                    {{ data.item.nombre +' '+data.item.primer_apellido}}
                  </div>
                </template>
                </v-autocomplete>
              </v-col>
              <!-- <v-col cols="12" md="2">
              <v-btn small color="blue darken-3" dark @click="addMagistrado()">
                <v-icon small left>mdi-plus</v-icon>
                Agregar
              </v-btn>
              </v-col> -->
              </v-row>
            </v-container>

            <v-container v-if="magistrados.length > 0">
            <v-card class="mt-n3">
              <v-card-title style="color: #B08836"  class="font-weight-bold">
                <h4 class="heading font-weight-bold"> Firmantes del Archivo</h4>
              </v-card-title>
              <v-row class="mt-n3">
                <v-col cols="12" md="10">
                  <ul>
                    <li
                      v-for="(magistrado,index) in magistrados"
                      v-bind:key="magistrado.nombre"
                      v-on:remove="magistrados.splice(index, 1)"
                    >
                      <h2 v-if="magistrado.segundo_apellido">
                        {{magistrado.nombre+' '+magistrado.primer_apellido+' '+magistrado.segundo_apellido}}
                        <v-btn x-small color="red darken-3" dark @click="removeMagistrado(index)">X</v-btn>
                      </h2>
                      <h2 v-else>
                        {{magistrado.nombre+' '+magistrado.primer_apellido}}
                        <v-btn x-small color="red darken-3" dark @click="removeMagistrado(index)">X</v-btn>
                      </h2>
                      <b v-if="magistrado.firmado == 1" style="color: green">Ya ha Firmado</b><br>
                    </li>
                  </ul>
                </v-col>
              </v-row>
            </v-card>
          </v-container>
          <!--FIN MULTIFIRMA -->
          <br>

          <v-row>
            <v-col cols="12" align="right">
              <v-btn
                tile
                color="primary"
                :loading="loading"
                :disabled="!valid"
                @click="validate()"
              >
                <v-icon left>
                  mdi-send
                </v-icon>
                Guardar Documento
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
    <v-dialog
      v-model="progress"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="#0A4A79"
        dark
      >
        <v-card-text>
          Cargando Archivo
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  const Swal = require('sweetalert2');
  import TableDetallesApelacion from "@/components/TableDetallesApelacion";
  import {SelectFileSign,message,SelectPfx,OpenPfx,PKCS7creado,extFileUpload,infoCer} from '@/services/cliente';
  import { CertificateRequest } from '@/services/clasesFirma';
  import { mapGetters } from "vuex";

  export default {
    components: { TableDetallesApelacion },
    data(){
      return {
        magistrado:'',
        magistrados: [],
        magistrados_ids: [],
        file_firel: [],
        password:'',
        showpass: false,
        activarBoton: false,
        loadingFirma: false,
        loadingResolucion: false,
        loading: false,
        progress: false,
        valid: true,
        apelacion_id: '',
        currentEnvio: {},
        currentApelacion:{},
        resolucion_proyecto: '',
        files:[],
        file:[],
        url_multifirma:'',
        bufferFile:'',
        resolucionProyectbase64:'',
        base64String: '',
        num_oficio:'',
        asunto:'',
        categoria:'',
        tipo_envio_id:'',
        tipo_documento:'',
        listTipo:[],
        leyenda:'',
        extracto:'',
        archivo:{
          encode:'',
          type:'application/pdf',
          file_name:'',
          size:''
        },
        archivoDefault:{
          encode:'',
          type:'application/pdf',
          file_name:'',
          size:''
        },
        sign:'',
        fileRules: [
          value => !value || value.size < 20971520 || 'El documento no debe exceder de 20MB',
          // v => !v || 'El Campo es Requerido',
        ],
        listTipoEnvios:[],
        listCategorias:[]
      }
    },
    computed: {
      formTitle () {
        return 'Seleccione archivo a firmar'
      },
      ...mapGetters([
          "currentUser",
          "listMagistrados",
          //"listTipoEnvios",
          "firmasList",
          "roleUser"
        ]),
    },
    watch: {
      tipo_envio_id: function (val) {
        if(val){
          // this.tipo_documento_id = ''
        }
      },
      categoria: function (val) {
        if(val){
          this.tipo_documento = ''
          this.leyenda = ''
        }
      },
      tipo_documento: function (val) {
        if(val){
          this.leyenda = ''
        }
      },
      sign: function (val) {
        if(val == '1'){
          this.magistrados = []
          this.magistrados_ids = []
        }
        else if (val == '2') {
          this.file_firel = []
          this.password = ''
          this.activarBoton = false
        }
        else if (val == '3') {
          this.magistrados = []
          this.magistrados_ids = []
          this.file_firel = []
          this.password = ''
          this.activarBoton = false
        }
      },
    },
    created() {
      this.apelacion_id =  JSON.parse(localStorage.getItem("currentApelacion"))
      this.currentEnvio =  localStorage.getItem("currentEnvio") || undefined
      if (this.currentEnvio) {
        this.currentEnvio = JSON.parse(this.currentEnvio);
        this.tipo_envio_id = this.currentEnvio.tipo_envio_id
        this.num_oficio = this.currentEnvio.num_oficio
        this.asunto = this.currentEnvio.asunto
      }
      this.showApelacion()
      this.getMagistrados()
      this.getCategorias()
      this.getTipoEnviosEApelaciones()
    },
    methods:{
      //PARA VALIDAR QUE EL NOMBRE DEL ARCHIVO NO CONTENGA "." NI CARARACTERES ESPECIALES PARA EVITAR ERROR EN LA GENERACION DE LA EVIDENCIA
      containsSpecialChars(str) {
        const specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
        return specialChars.test(str);
      },
      validaNombreDeArchivo(file) {
        let filename = file.name
        let onlyname_without_extension = filename.substring(0, filename.lastIndexOf('.'));
        let result = this.containsSpecialChars(onlyname_without_extension);
        if(result){
          Swal.fire({
            icon: 'warning',
            title: 'El nombre del documento NO debe contener "puntos" ni caracteres especiales como . ! @ # $ % ^ & * ( ) + ~',
            confirmButtonText: "Aceptar",
          })
          return false;
        }
        return true
      },

      //Metodos Firel
      SelccionarArchivo(file) {
        if (this.file && this.file.name) {
          let is_valid_name_oficio_apelacion = this.validaNombreDeArchivo(file);
          if(! is_valid_name_oficio_apelacion){
            this.file= []
            return false;
          }
          SelectFileSign(file).then((isValidFile)=>{
              if(isValidFile){
                  this.message=message;
                  this.extArchivoCargado=extFileUpload;
              }
           });
          this.files = []
          this.fileSelected()
        } else {
          this.files = []
        }
      },
      SeleccionarPfx(filePFX) {
        if (filePFX) {
          this.activarBoton=SelectPfx(filePFX);
          if(this.activarBoton){
              this.filePFXselct=filePFX;
          }
        }
      },
      firmar() {
        OpenPfx(this.filePFXselct,this.password).then((isCreatePKCS7)=>{
            if(isCreatePKCS7){
              if (!infoCer.VigenciaValida) {
                    Swal.fire({
                      icon: 'warning',
                      title: 'La vigencia de su Firel no es válida',
                      confirmButtonText: "Aceptar",
                    })
                    return false
                  }
                var fecha = new Date();
                this.pkcs7=PKCS7creado;
                this.FileName = "pkcs7_" + fecha.valueOf() + "." + this.extArchivoCargado;
                this.creaEvidencia(this.pkcs7);
            } else {
              Swal.fire({
                icon: 'warning',
                title: 'Archivo PFX o contraseña inválida, Favor de Verificar',
                confirmButtonText: "Aceptar",
              })
            }
         });
      },
      creaEvidencia(pkcs7) {
          Swal.fire({
            title: 'Estableciendo comunicación',
            html: 'Generando Evidencia Criptográfica ...',
            allowOutsideClick: false,
            showConfirmButton: false,
            onBeforeOpen: () => {
              Swal.showLoading()
            },
          })
        this.creaevidencia=true;
        this.loadingFirma = true;
        this.loadingeFirma = true;
        // let archivos = this.pkcs7.nativeElement.files;
        if(pkcs7){
           CertificateRequest.CertificateType = 3;
           CertificateRequest.Pkcs7Original = this.pkcs7;
           CertificateRequest.FileName = this.FileName;
           CertificateRequest.UserName = "Eliminar";
           this.$store.dispatch("FIREL_FIRMA", { url: "promocion/firmar", data: CertificateRequest })
           .then(response => {
             Swal.close();
             // console.log(response.data);
             this.loadingFirma = false;
             this.loadingeFirma = false;
             Swal.fire({
               icon: 'success',
               title: 'Documento Firmado con Éxito',
               confirmButtonText: "Aceptar",
               timer: 1500,
             })
             this.archivo.encode = response.data.data.resultados.PdfBase64;
             this.archivo.size = this.file.size;
             var fecha = new Date();
             this.archivo.file_name = "evidencia_" + fecha.valueOf();
            //  this.sign = '';
             this.file_firel = [];
            //  this.file = [];
             this.password = '';
             this.activarBoton = false;
            //  this.$refs.evidencia.resetValidation()
           })
           .catch(err => {
             console.log(err);
             this.loadingFirma = false;
           });
        } else {
          this.creaevidencia=false;
        }
      },

      arrayBufferToBase64( buffer ) {
            var binary = '';
            var bytes = new Uint8Array( buffer );
            var len = bytes.byteLength;
            for (var i = 0; i < len; i++) {
              binary += String.fromCharCode( bytes[ i ] );
            }
            return window.btoa( binary );
      },

      saveTextAsFile() {
        var fileB64 = this.archivo.encode
        var fecha = new Date();
        let blob = this.b64toBlob(fileB64, 'application/pdf', 512);
        let fileNameToSaveAs = "evidencia_" + fecha.valueOf() + ".pdf";
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('target' ,'_blank');
        // link.setAttribute('download', fileNameToSaveAs);
        document.body.appendChild(link);
        link.click();
      },
      b64toBlob(b64Data, contentType, sliceSize) {
        contentType = contentType || '';
        sliceSize = sliceSize || 512;

        var byteCharacters = atob(b64Data);
        var byteArrays = [];

        for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
          var slice = byteCharacters.slice(offset, offset + sliceSize);

          var byteNumbers = new Array(slice.length);
          for (var i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }

          var byteArray = new Uint8Array(byteNumbers);

          byteArrays.push(byteArray);
        }

        var blob = new Blob(byteArrays, { type: contentType });
        return blob;
      },

      getMagistrados(){
        this.$store.dispatch("GET_MAGISTRADOS",  { url: "/magistrados" }).then(response => {
            // console.log(response.data);
        }).catch(error => {
          console.log(error);
        });
      },

      getTipoEnviosEApelaciones(){
        this.$store.dispatch("GET_TIPO_ENVIO_AE",  { url: "/tipo-envios" }).then(response => {
          const { tipo_envios } = response.data.data
          this.listTipoEnvios = tipo_envios
        }).catch(error => {
          console.log(error);
        });
      },

      getCategorias(){
        this.$store.dispatch("GET_CATEGORIAS",  { url: "/categorias" }).then(response => {
          const { data } = response.data
          this.listCategorias = data
        }).catch(error => {
          console.log(error);
        });
      },

      getTipoDocumento(){
        this.listTipo = []
        this.$store.dispatch("GET_TIPO_DOCUMENTO",  { url: "/tipos-documentos",
        params: {
          categoria_id: this.categoria.id
        }
        }).then(response => {
          this.listTipo = response.data.data.tipos_documentos
        }).catch(error => {
          console.log(error);
        });
      },

      validate() {
        if (this.$refs.form.validate()) {
          if ((this.file == "" || this.file == null) && (this.roleUser != 'relator')) {
            Swal.fire({
              icon: 'warning',
              title: 'Selecciona un Documento',
              confirmButtonText: "Aceptar",
            })
            this.loading = false
          }
          else if(this.magistrados_ids.length == 0 && this.sign == "2"){
            Swal.fire({
              icon: 'warning',
              title: 'Favor de Agregar Firmantes',
              confirmButtonText: "Aceptar",
            })
          }  
          else if(!this.archivo.encode && this.sign == "1"){
            Swal.fire({
              icon: 'warning',
              title: 'Favor de Firmar Documento',
              confirmButtonText: "Aceptar",
            })
          } 
          else {
            this.loading = true
            if (this.sign == "1") {
              this.url_multifirma = "/documento/"+ this.currentApelacion.id +"/firma"// pendiente
              this.saveFirma() // pendiente
            } else if (this.sign == "2") {
              this.url_multifirma = "/documento/"+ this.currentApelacion.id +"/multifirma"
              this.saveMultifirma()
            } else if (this.sign == "3") {
              this.url_multifirma = "/documento/"+ this.currentApelacion.id +"/firma" // url para guardar documento sin firmar
              this.FilesToUpload()
              this.saveFirma()
            }
          }
        }
        else {
          Swal.fire({
            icon: 'error',
            title: 'Favor de verificar los campos Requeridos',
            confirmButtonText: "Aceptar",
          })
        }
      },

      saveFirma() {
        const data = {
          file: this.archivo,
          num_oficio: this.num_oficio,
          tipo_envio_id: this.tipo_envio_id,
          debe_contestar: this.tipo_envio_id == 1 ? 1 : 2,
          tipo_documento_id: this.tipo_documento.id,
          leyenda: this.leyenda,
          extracto: this.extracto,
          envio_id: this.currentEnvio ? this.currentEnvio.id : undefined,
          asunto: this.asunto,
          crear_comunicado: true
        }
        this.$store.dispatch("CREATE_MULTIFIRMA",  { url: this.url_multifirma, data: data })
        .then(response => {
          Swal.fire({
            icon: 'success',
            title: 'Documento guardado con éxito',
            timer: 1500,
          })
          this.loading = false
          this.$router.replace({ name:'Comunicados' })
        })
          .catch(error => {
            this.loading = false
            console.log(error);
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: error.response.data.message,
              confirmButtonText: "Aceptar"
            });
          });
      },
      saveMultifirma() {
        if (this.roleUser != 'relator') {
          this.FilesToUpload()
        }
        const data = {
          magistrados: this.magistrados_ids,
          file: this.archivo,
          tipo_envio_id: this.tipo_envio_id,
          tipo_documento_id: this.tipo_documento.id,
          leyenda: this.leyenda,
          extracto: this.extracto,
          envio_id: this.currentEnvio ? this.currentEnvio.id : undefined,
          num_oficio: this.num_oficio,
          debe_contestar: this.tipo_envio_id == 1 ? 1 : 2,
          asunto: this.asunto,
          crear_comunicado: true
        }
        this.$store.dispatch("CREATE_MULTIFIRMA",  { url: this.url_multifirma, data: data })
        .then(response => {
          Swal.fire({
            icon: 'success',
            title: 'Documento y Firmantes Registrados con Éxito',
            timer: 1500,
          })
          this.loading = false
          this.$router.replace({ name:'Comunicados' })
        }).catch(error => {
            this.loading = false
            console.log(error);
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: error.response.data.message,
              confirmButtonText: "Aceptar"
            });
          });
      },
      showApelacion(){
        this.$store.dispatch("SHOW_APELACION", {
          url:"/apelacion/"+ this.apelacion_id,
        } )
        .then((response) => {
          this.currentApelacion = response.data.data.apelacion
          this.resolucion_proyecto = response.data.data.resolucion_proyecto
        })
        .catch(err => {
          console.log(err);
        });
      },
      fileSelected(){
        var file = this.file;
        this.getBase64(file).then(data => {
          this.files.push(data);
        });
      },
      getBase64(file) {
        return new Promise((resolve, reject) => {
          if (file) {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
          }
        });
      },
      FilesToUpload() {
        if (this.files.length) {
          this.files.forEach(file => {
            var block = file.split(";");
            // Get the content type of the image
            var contentType = block[0].split(":")[1]; // In this case "jpg
            // get the real base64 content of the file
            this.archivo['type'] = contentType
            var realData = block[1].split(",")[1];
            //console.log(realData);
            this.archivo['encode'] = realData
            this.archivo['size'] = this.file.size
            this.archivo['file_name'] = this.file.name.split(".pdf")[0];
            // console.log(this.archivo.file_name);
          });
        }
      },
      addMagistrado() {
        if (this.magistrado=="") {
          Swal.fire({
            icon: 'warning',
            title: 'No se ha seleccionado Magistrado',
            showConfirmButton: false,
            timer: 1500
          })
        } else if (this.magistrados_ids.includes(this.magistrado.id)) {
          Swal.fire({
            icon: 'warning',
            title: this.magistrado.nombre + ' ya ha sido agregado',
            showConfirmButton: false,
            timer: 1500
          })
          this.magistrado = ''
          // this.$refs.form.reset()
        } else {
          this.magistrados.push(this.magistrado)
          this.magistrados_ids.push(this.magistrado.id)
          this.magistrado = ''
          // this.$refs.form.reset()
        }
      },
      getFile(){
        this.progress = true
        this.loadingResolucion = true
        this.$store.dispatch("GET_FILE", { url: "/cuenta/"+ this.resolucion_proyecto.id +"/file" }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('target' ,'_blank');
            document.body.appendChild(link);
            link.click();
            this.progress = false
            this.loadingResolucion = false
          })
          .catch(err => {
            console.log(err);
            this.loadingResolucion = false
            this.progress = false
          });
      },
      removeMagistrado(index) {
        this.magistrados.splice(index, 1)
        this.magistrados_ids.splice(index, 1)
      },
      close () {
        this.$refs.form.resetValidation()
        this.$refs.form.reset()
        this.archivo = Object.assign({}, this.archivoDefault)
        this.files = []
        this.file = []
      },

    }
  }
</script>
